import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e12bff16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "videoPlay" }
const _hoisted_2 = { class: "back" }
const _hoisted_3 = {
  controls: "",
  class: "videoArea"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 你的手机不支持播放该视频文件 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: "iconfont icon-fanhui",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backHandler && _ctx.backHandler(...args)))
      })
    ]),
    _createElementVNode("video", _hoisted_3, [
      _createElementVNode("source", {
        src: _ctx.otherParams.url,
        type: "video/mp4"
      }, null, 8, _hoisted_4),
      _hoisted_5
    ])
  ]))
}